import React, { Component } from 'react'
import { routerActions } from 'connected-react-router'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import AppHeader from '../components/AppHeader'
import * as Reservation from '../store/Reservations'
import * as Events from '../store/Events'
import moment from 'moment'
import { Button, Container, Header } from 'semantic-ui-react'
import { withAdalLoginApi } from '../adalConfig'

class CheckInPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            reservation: null,
            event: null,
        }
    }
    async componentDidMount() {
        const { actions, confirmation } = this.props
        const { response: reservation } = await actions.getReservation(confirmation)
        const { response: event } = await actions.getEvent(reservation.inventory.eventId)

        this.setState({ reservation, event })
    }
    render() {
        const { actions, confirmation } = this.props
        const { reservation, event } = this.state
        if (!reservation) {
            return (
                <div className="app">
                    <AppHeader />
                    <div className="bigimage"></div>
                    <Container>
                        <Header className="page title" as="h1" content={`Welcome`} />
                        <Header as="h3" content={confirmation && `Reservation Confirmation: ${confirmation}`} />
                    </Container>
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', marginTop: 25 }}>
               <a rel="noopener noreferrer" href="https://s3.us-east-2.amazonaws.com/denisonparking-static/FAQ.pdf" target="_blank">
                                       F.A.Q.
                                   </a>
                                   <Header as="h4" content={`If you close your browser, you must restart the registration process again`} />
                </div>
                </div>
            )
        }

        const checkIn = (e, { data }) => checkInCheckOut({ confirmationNumber: confirmation, reservationBlockId: data.id, action: 1 })
        const checkOut = (e, { data }) => checkInCheckOut({ confirmationNumber: confirmation, reservationBlockId: data.id, action: -1 })

        const checkInCheckOut = async (checkin) => {
            try {
                await actions.checkInReservation(checkin)
                const { response: reservation } = await actions.getReservation(confirmation)
                this.setState({ reservation })
            } catch (error) {
                console.log(error)
            }
        }

        const { spots } = reservation

        const blocks = reservation.blocks.map((b) => ({
            ...b,
            eventBlock: event.blocks.find((eb) => eb.id === b.inventoryBlock.eventBlockId),
            available: b.checkins.filter((c) => c.reservationBlockId === b.id).reduce((pv, cv) => pv + cv.action, 0),
        }))

        console.log(blocks)
        return (
            <div className="app">
                <AppHeader />
                <div className="bigimage"></div>
                <Container>
                    <Header className="page title" as="h1" content={`Welcome ${event.name}`} />
                    <Header as="h2" content={confirmation && `Reservation Found: Confirmation #${confirmation}`} />
                    <Header as="h3" content="Parker Details" />
                    <div>
                        <div>{reservation.name}</div>
                        <div>{`${reservation.address},${reservation.address2 ? ' ' + reservation.address2 + ',' : ''} ${reservation.city}, ${reservation.state} ${
                            reservation.zip
                        }`}</div>
                        <div>{reservation.mobile}</div>
                        <div>{reservation.email}</div>
                    </div>
                    <div className="checkin options">
                        {blocks.map((block) => (
                            <div
                                className="option"
                                style={{
                                    textAlign: 'unset',
                                    borderWidth: 2,
                                    borderColor: colourNameToHex(block.eventBlock.tagColor),
                                    backgroundColor: colourNameToHex(block.eventBlock.tagColor, 128),
                                }}
                            >
                                <Header style={{ marginLeft: 10 }} content={`${block.inventoryBlock.name}`} />
                                <div>
                                    <Header
                                        style={{ marginLeft: 15, marginBottom: 0, marginTop: 0 }}
                                        as="h4"
                                        content={`${moment(block.eventBlock.startDate).format('MMMM Do YYYY')} to ${moment(block.eventBlock.endDate).format('MMMM Do YYYY')}`}
                                    />
                                    <Header
                                        style={{ marginLeft: 15, marginBottom: 0, marginTop: 0 }}
                                        as="h4"
                                        content={`${moment(block.eventBlock.startDate).format('h:mm A')} to ${moment(block.eventBlock.endDate).format('h:mm A')}`}
                                    />

                                    <Header style={{ marginLeft: 15, marginBottom: 0, marginTop: 10 }} as="h4" content={`${spots - block.available} of ${spots} available`} />
                                </div>
                                <div style={{ marginTop: 10, marginLeft: 15 }}>
                                    <Button primary content="Check-In" data={block} style={{ marginRight: 10 }} onClick={checkIn} disabled={spots - block.available === 0} />
                                    <Button content="Check-Out" data={block} onClick={checkOut} disabled={spots - block.available === spots} />
                                </div>
                            </div>
                        ))}
                    </div>
                </Container>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', marginTop: 25 }}>
               <a rel="noopener noreferrer" href="https://s3.us-east-2.amazonaws.com/denisonparking-static/FAQ.pdf" target="_blank">
                                       F.A.Q.
                                   </a>
                                   <Header as="h4" content={`If you close your browser, you must restart the registration process again`} />
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        confirmation: ownProps.match.params.confirmation.toLowerCase(),
    }
}

const mapDispatchToProps = (dispatch) => ({
    actions: {
        ...bindActionCreators(Reservation.actionCreators, dispatch),
        ...bindActionCreators(Events.actionCreators, dispatch),
        ...bindActionCreators(routerActions, dispatch),
    },
})
export default withAdalLoginApi(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(CheckInPage)
)

function colourNameToHex(colour, alpha) {
    var colours = {
        aliceblue: '#f0f8ff',
        antiquewhite: '#faebd7',
        aqua: '#00ffff',
        aquamarine: '#7fffd4',
        azure: '#f0ffff',
        beige: '#f5f5dc',
        bisque: '#ffe4c4',
        black: '#000000',
        blanchedalmond: '#ffebcd',
        blue: '#0000ff',
        blueviolet: '#8a2be2',
        brown: '#a52a2a',
        burlywood: '#deb887',
        cadetblue: '#5f9ea0',
        chartreuse: '#7fff00',
        chocolate: '#d2691e',
        coral: '#ff7f50',
        cornflowerblue: '#6495ed',
        cornsilk: '#fff8dc',
        crimson: '#dc143c',
        cyan: '#00ffff',
        darkblue: '#00008b',
        darkcyan: '#008b8b',
        darkgoldenrod: '#b8860b',
        darkgray: '#a9a9a9',
        darkgreen: '#006400',
        darkkhaki: '#bdb76b',
        darkmagenta: '#8b008b',
        darkolivegreen: '#556b2f',
        darkorange: '#ff8c00',
        darkorchid: '#9932cc',
        darkred: '#8b0000',
        darksalmon: '#e9967a',
        darkseagreen: '#8fbc8f',
        darkslateblue: '#483d8b',
        darkslategray: '#2f4f4f',
        darkturquoise: '#00ced1',
        darkviolet: '#9400d3',
        deeppink: '#ff1493',
        deepskyblue: '#00bfff',
        dimgray: '#696969',
        dodgerblue: '#1e90ff',
        firebrick: '#b22222',
        floralwhite: '#fffaf0',
        forestgreen: '#228b22',
        fuchsia: '#ff00ff',
        gainsboro: '#dcdcdc',
        ghostwhite: '#f8f8ff',
        gold: '#ffd700',
        goldenrod: '#daa520',
        gray: '#808080',
        green: '#008000',
        greenyellow: '#adff2f',
        honeydew: '#f0fff0',
        hotpink: '#ff69b4',
        'indianred ': '#cd5c5c',
        indigo: '#4b0082',
        ivory: '#fffff0',
        khaki: '#f0e68c',
        lavender: '#e6e6fa',
        lavenderblush: '#fff0f5',
        lawngreen: '#7cfc00',
        lemonchiffon: '#fffacd',
        lightblue: '#add8e6',
        lightcoral: '#f08080',
        lightcyan: '#e0ffff',
        lightgoldenrodyellow: '#fafad2',
        lightgrey: '#d3d3d3',
        lightgreen: '#90ee90',
        lightpink: '#ffb6c1',
        lightsalmon: '#ffa07a',
        lightseagreen: '#20b2aa',
        lightskyblue: '#87cefa',
        lightslategray: '#778899',
        lightsteelblue: '#b0c4de',
        lightyellow: '#ffffe0',
        lime: '#00ff00',
        limegreen: '#32cd32',
        linen: '#faf0e6',
        magenta: '#ff00ff',
        maroon: '#800000',
        mediumaquamarine: '#66cdaa',
        mediumblue: '#0000cd',
        mediumorchid: '#ba55d3',
        mediumpurple: '#9370d8',
        mediumseagreen: '#3cb371',
        mediumslateblue: '#7b68ee',
        mediumspringgreen: '#00fa9a',
        mediumturquoise: '#48d1cc',
        mediumvioletred: '#c71585',
        midnightblue: '#191970',
        mintcream: '#f5fffa',
        mistyrose: '#ffe4e1',
        moccasin: '#ffe4b5',
        navajowhite: '#ffdead',
        navy: '#000080',
        oldlace: '#fdf5e6',
        olive: '#808000',
        olivedrab: '#6b8e23',
        orange: '#ffa500',
        orangered: '#ff4500',
        orchid: '#da70d6',
        palegoldenrod: '#eee8aa',
        palegreen: '#98fb98',
        paleturquoise: '#afeeee',
        palevioletred: '#d87093',
        papayawhip: '#ffefd5',
        peachpuff: '#ffdab9',
        peru: '#cd853f',
        pink: '#ffc0cb',
        plum: '#dda0dd',
        powderblue: '#b0e0e6',
        purple: '#800080',
        rebeccapurple: '#663399',
        red: '#ff0000',
        rosybrown: '#bc8f8f',
        royalblue: '#4169e1',
        saddlebrown: '#8b4513',
        salmon: '#fa8072',
        sandybrown: '#f4a460',
        seagreen: '#2e8b57',
        seashell: '#fff5ee',
        sienna: '#a0522d',
        silver: '#c0c0c0',
        skyblue: '#87ceeb',
        slateblue: '#6a5acd',
        slategray: '#708090',
        snow: '#fffafa',
        springgreen: '#00ff7f',
        steelblue: '#4682b4',
        tan: '#d2b48c',
        teal: '#008080',
        thistle: '#d8bfd8',
        tomato: '#ff6347',
        turquoise: '#40e0d0',
        violet: '#ee82ee',
        wheat: '#f5deb3',
        white: '#ffffff',
        whitesmoke: '#f5f5f5',
        yellow: '#ffff00',
        yellowgreen: '#9acd32',
    }

    if (typeof colours[colour.toLowerCase()] != 'undefined') {
        return alpha ? colours[colour.toLowerCase()] + toHex(alpha) : colours[colour.toLowerCase()]
    }

    return false
}

const toHex = (d) => {
    const hex = d.toString(16)
    if (hex.length < 2) {
        return '0' + hex
    }
    return hex
}
